module.exports = __webpack_public_path__ + "img/05王泰锡.3ba6f854.png";